<template>
    <div class="wizzard__notification-container">
        <input-field label="Remind me via" :field="$v.via" type="select2" :options="via_options"
                     class="form__group--notifications-via"></input-field>
        <input-field label="When" :field="$v.when" type="number" class="form__group--notifications-when"></input-field>
        <input-field label="What" :field="$v.what" type="select2" :options="what_options"
                     class="form__group--notifications-what"></input-field>
        <div @click="$emit('delete')" class="button button--small button--gray button--red-on-hover icon icon-x"></div>
    </div>
</template>
<script>
    import InputField from "./popups/InputField";
    import {required, integer, minValue} from 'vuelidate/lib/validators';

    export default {
        name: 'reminder-form',
        components: {InputField},
        props: ['value'],
        data() {
            return {
                via: "",
                when: 0,
                what: "",
                via_options: [
                    {
                        'id': 'email',
                        'text': 'Email'
                    },
                ],
                what_options: [
                    {id: 'days', text: 'days'},
                    {id: 'weeks', text: 'weeks'},
                    {id: 'months', text: 'months'}
                ]
            }
        },
        computed: {
            joinedProperties() {
                return `${this.via}|${this.when}|${this.what}`;
            },
        },
        beforeMount: function () {
            this.via = this.value.via;
            this.when = this.value.when;
            this.what = this.value.what;
        },
        validations: {
            via: {required},
            when: {required, integer, minValue: minValue(1)},
            what: {required},
        },
        methods: {
            updateData: function () {
                this.$v.$touch()
                if (!this.$v.$invalid) {
                    this.$emit('input', {
                        via: this.via,
                        when: this.when,
                        what: this.what,
                    })
                }
            }
        },
        watch: {
            joinedProperties() {
                this.updateData()
            }
        }
    }
</script>